import Vue from 'vue';
import PopoverAvatar from '~/components/PopoverAvatar.vue';

document.addEventListener('readystatechange', () => {
  window.initPopoverAvatar();
});

window.initPopoverAvatar = () => {
  $('span[data-vue="popover-avatar"]').each(
    (_, el) =>
      new Vue({
        el,
        name: `PopoverAvatar ${el.dataset.id}`,
        render: (h) =>
          h(PopoverAvatar, {
            props: {
              ...el.dataset,
              html: el.innerHTML,
            },
          }),
      }),
  );
};
